import { render, staticRenderFns } from "./card3.vue?vue&type=template&id=c09c4120&"
import script from "./card3.vue?vue&type=script&lang=js&"
export * from "./card3.vue?vue&type=script&lang=js&"
import style0 from "./card3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports